// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-dev-container {
  padding: 24px;
  max-width: 1100px;
  margin: 0 auto;
}

.process-dev-container h1 {
  margin-bottom: 6px;
}

.subtitle {
  margin-top: 0;
  opacity: 0.8;
  margin-bottom: 18px;
}

.analog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 14px;
}

@media (max-width: 980px) {
  .analog-grid {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media (max-width: 620px) {
  .analog-grid {
    grid-template-columns: 1fr;
  }
}

.analog-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.analog-card-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.analog-card-header h3 {
  font-size: 16px;
  margin: 0;
}

.analog-tagname {
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
}

.analog-card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.analog-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px dashed rgba(0, 0, 0, 0.1);
  padding-top: 8px;
}

.analog-row:first-child {
  border-top: none;
  padding-top: 0;
}

.label {
  opacity: 0.75;
}

.value {
  font-weight: 700;
}

/* Timestamp باید مثل فونت label باشد */
.value-timestamp {
  font-weight: normal;
  opacity: 0.75;
}

/* ===== Gauge SVG ===== */
.gauge-svg-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 2px 0 2px 0;
}

.gauge-arc {
  fill: none;
  stroke: rgba(0, 0, 0, 0.18);
  stroke-width: 12;
  stroke-linecap: round;
}

.gauge-tick {
  stroke: rgba(0, 0, 0, 0.35);
  stroke-width: 2;
}

.gauge-tick-text {
  fill: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}

.gauge-needle {
  stroke: rgba(0, 0, 0, 0.85);
  stroke-width: 3;
  stroke-linecap: round;
}

.gauge-needle-base {
  stroke: rgba(0, 0, 0, 0.35);
  stroke-width: 3;
  stroke-linecap: round;
}

.gauge-cap {
  fill: rgba(0, 0, 0, 0.85);
}

.gauge-value {
  fill: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProcessDevelopment.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".process-dev-container {\n  padding: 24px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.process-dev-container h1 {\n  margin-bottom: 6px;\n}\n\n.subtitle {\n  margin-top: 0;\n  opacity: 0.8;\n  margin-bottom: 18px;\n}\n\n.analog-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n@media (max-width: 980px) {\n  .analog-grid {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media (max-width: 620px) {\n  .analog-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.analog-card {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  padding: 14px;\n  background: #fff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n}\n\n.analog-card-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.analog-card-header h3 {\n  font-size: 16px;\n  margin: 0;\n}\n\n.analog-tagname {\n  font-size: 12px;\n  opacity: 0.7;\n  white-space: nowrap;\n}\n\n.analog-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.analog-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  border-top: 1px dashed rgba(0, 0, 0, 0.1);\n  padding-top: 8px;\n}\n\n.analog-row:first-child {\n  border-top: none;\n  padding-top: 0;\n}\n\n.label {\n  opacity: 0.75;\n}\n\n.value {\n  font-weight: 700;\n}\n\n/* Timestamp باید مثل فونت label باشد */\n.value-timestamp {\n  font-weight: normal;\n  opacity: 0.75;\n}\n\n/* ===== Gauge SVG ===== */\n.gauge-svg-wrap {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin: 2px 0 2px 0;\n}\n\n.gauge-arc {\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.18);\n  stroke-width: 12;\n  stroke-linecap: round;\n}\n\n.gauge-tick {\n  stroke: rgba(0, 0, 0, 0.35);\n  stroke-width: 2;\n}\n\n.gauge-tick-text {\n  fill: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n\n.gauge-needle {\n  stroke: rgba(0, 0, 0, 0.85);\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n\n.gauge-needle-base {\n  stroke: rgba(0, 0, 0, 0.35);\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n\n.gauge-cap {\n  fill: rgba(0, 0, 0, 0.85);\n}\n\n.gauge-value {\n  fill: rgba(0, 0, 0, 0.85);\n  font-weight: 700;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
